import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { BrandingHTMLInjectorService } from '@app/shared/services/branding-htmlinjector.service';

@Component({
	selector: 'app-help-page',
	templateUrl: './help-page.component.html',
	styleUrls: ['./help-page.component.css']
})
export class HelpPageComponent implements OnInit {

	constructor(private _brandingHtmlInjector: BrandingHTMLInjectorService) { }

	ngOnInit(): void {
		this.injectBranding();
	}

	public brandingHelp?: SafeHtml;

	private async injectBranding(): Promise<void> {
		this.brandingHelp = await this._brandingHtmlInjector.getInjectableHTMLFromFile('./branding/html/help.html');
	}
}
